import Helpers from "../../utils/helpers";
import { useTranslation } from "react-i18next";
import { getOrderReviewTotals, toRoundedWholeNumber } from "./order-review-calculations";

const OrderReviewTotal = (props: any) => {
  const { t } = useTranslation();


  if (!props.orderedItems) {
    return null;
  }
  const orderInfo = props.orderedItems?.props?.orderinfo;
  const totals = getOrderReviewTotals(orderInfo, { includeNegativeAmounts: true });
  return (
    <div className="flex align-items-left justify-content-between px-3">
      <div className="col md:col-6 lg:col-6 ml-1">
        <label>Comments: </label>
        <label>{props.orderedItems?.props?.orderinfo?.comment || "No comments"}</label>
      </div>
      <div className="col col-1"></div>
      <div className="col-6 md:col-6 lg:col-3">
        <p className="m-1" style={{ lineHeight: "1.5" }}>
          Total Cost :
        </p>
        <p className="m-1" style={{ lineHeight: "1.5" }}>
          Total Tax:
        </p>
        <p className="m-1" style={{ lineHeight: "1.5" }}>
          Courier Charges :
        </p>
        <p
          className="m-1 font-bold"
          style={{ lineHeight: "1.5", color: "#16a34a" }}
        >
          Total :
        </p>
        {totals.rewardPointAmount > 0 && (
          <>
            <p className="m-1" style={{ lineHeight: "1.5" }}>
              Reward Amount :
            </p>
            <p className="m-1 font-bold" style={{ lineHeight: "1.5", color: "#16a34a" }}>
              Total Amount Paid :
            </p>
          </>
        )}
      </div>
      <div className="col-6 md:col-6 lg:col-2 text-right">
        <p className="m-1" style={{ lineHeight: "1.5" }}>
          {Helpers.formatAmountInINR(totals.taxableAmount)}
        </p>
        <p className="m-1" style={{ lineHeight: "1.5" }}>
          {Helpers.formatAmountInINR(totals.taxAmount)}
        </p>
        <p className="m-1" style={{ lineHeight: "1.5" }}>
          {Helpers.formatAmountInINR(totals.courierCharges)}
        </p>
        <p
          className="m-1 font-bold"
          style={{ lineHeight: "1.5", color: "#16a34a" }}
        >
          {Helpers.formatAmountInINR(toRoundedWholeNumber(totals.totalBeforeReward))}
        </p>
        {totals.rewardPointAmount > 0 && (
          <p className="m-1" style={{ lineHeight: "1.5" }}>
            {Helpers.formatAmountInINR(totals.rewardPointAmount)}
          </p>
        )}
        {totals.rewardPointAmount > 0 && (
          <p className="m-1 font-semibold text-green font-bold" style={{ lineHeight: "1.5" }}>
            {Helpers.formatAmountInINR(toRoundedWholeNumber(totals.payableAmount))}
          </p>
        )}
      </div>
    </div>
  );
};

export default OrderReviewTotal;